import { postcodeValidator } from 'postcode-validator';

type PostalCodeValidation = {
  countryCode: string;
  isGermany: boolean;
  isIreland: boolean;
  isPostcodeValid: boolean;
};

export const validatePostalCode = (postcode: string, country: string): PostalCodeValidation => {
  // countryCode must be upperCase for postcodeValidator
  const countryCode = (country ?? 'DE').toUpperCase();
  const isGermany = countryCode === 'DE';
  const isIreland = countryCode === 'IE';

  // Ireland isn't validated and therefore always valid
  // postcode must be upperCase because it is only validated by capital letters
  const isPostcodeValid = isIreland || (postcode !== '' && postcodeValidator(postcode.toUpperCase(), countryCode));

  return {
    countryCode,
    isGermany,
    isIreland,
    isPostcodeValid,
  };
};
